import React from 'react';

import { useLinkTextToAvoidInJobSearchesState, useLinkTextToAvoidInJobSearchesActions } from './LinkTextToAvoidInJobSearchesContext';
import { deleteLinkText } from './restApi';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';

const DeleteLinkTextForm = () => {
  const state = useLinkTextToAvoidInJobSearchesState();
  const { onResponse, onError, closeDeleteLinkTextModal } = useLinkTextToAvoidInJobSearchesActions();

  const handleDelete = () => {
    const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

    deleteLinkText({
      linkTextId: state.linkTextToDelete.id,
      onResponse,
      onError,
      body: {
        authenticityToken,
      },
    });
  };

  return (
    <div>
      <p>
        Are you sure you want to delete "<strong>{state?.linkTextToDelete?.value}</strong>" from the avoid list?
      </p>
      <ActionRow>
        <Button onClick={closeDeleteLinkTextModal}>
          Cancel
        </Button>
        <Button onClick={handleDelete} variant="danger">
          Delete
        </Button>
      </ActionRow>
    </div>
  );
};

export default DeleteLinkTextForm;
